/* eslint-disable indent */
import api from 'api/api';
import { DEVICE_ID } from 'utils/constants';
import { AxiosStatus } from 'api/axiosConfig';
import auth from 'utils/auth';
import { IApiResponse } from 'utils/models';
import { ICardsState, IFormValues, IValidatePrepaidCardResponse } from './SingleCardLoad.model';

export const validatePrepardCard = (customerId: string) =>
  api.get<IValidatePrepaidCardResponse>(`/transfer/validatePrepaidCard?customerId=${customerId}`, {}, true, true);

export const getCardTypes = () => api.get('/servicereq/cardTypes');

export const getCustomerInfo = () => api.get(`beneficiary/prepaidcard?type=&loginId=${auth.data?.loginId ?? ''}`);

interface IOnSubmitsProps {
  setSubmitStatus: (submitStatus: AxiosStatus) => void;
  setSuccessMsg: (successMsg: string) => void;
  setErrorMsg: (errorMsg: string) => void;
}

// eslint-disable-next-line operator-linebreak
export const ON_SUBMITS =
  ({ setSubmitStatus, setSuccessMsg, setErrorMsg }: IOnSubmitsProps) =>
  (values: IFormValues, form, otp: string, state: ICardsState, beneficiaryData, saveBen: boolean) => {
    const requestBody = {
      ...values,
      last4Digit: values.last4Digit,
      passwordType: 'OTP',
      password: otp,
      phoneNumber: values.phoneNumber,
      benName: values.cardName,
      transType: 'PREPAIDCARD-TRANSFER',
      deviceID: DEVICE_ID,
      saveBen,
    };
    return api
      .post('transfer/toPrepaidCard', requestBody)
      .then((response: IApiResponse) => {
        setSubmitStatus(AxiosStatus.SUCCESS);
        setSuccessMsg(response.description);
      })
      .catch((error: IApiResponse) => {
        console.error('error', error);
        setSubmitStatus(AxiosStatus.FAILURE);
        setErrorMsg(error.description);
      });
  };
